export const goalsContent = {
  hero: {
    title: "The Seeds We're Planting",
    subtitle: "This movement grows in phases. Here's where we're going—and what your support makes possible."
  },
  phases: {
    title: "The Three Phases",
    items: [
      {
        title: "PHASE 1: BUILD THE MOVEMENT",
        status: "WE ARE HERE",
        description: "We're growing the founding community through:\n• The Sacred Soil Alphabet (first edition art)\n• In-person connections at art shows and farmer's markets\n• Spreading the message that soil deserves a seat at the table\n\nYour purchase at this phase makes you a founding member."
      },
      {
        title: "PHASE 2: CREATE CERTIFICATION",
        status: "NEXT",
        description: "As the movement grows, we'll develop:\n• Certification standards for regenerative businesses\n• A recognizable mark that means( price in soil regeneration to products)\n• Consumer education to shift market demand\n\n\"Is it food? Or is it anti-food?\""
      },
      {
        title: "PHASE 3: SUPPORT & LOOP",
        status: "FUTURE",
        description: "With enough community members and resources, we'll:\n• Fund certified regenerative businesses directly\n• Create economic relationships that lead into our certification\n\nWork towards a future where there is always an option to support earth with every opportunity to spend money."
      }
    ]
  },
  seeds: {
    title: "What We're Growing",
    description: "These are the seeds that will grow from the movement. Your support makes it possible for these in-person experiences and the development of our regenerative business framework.",
    items: [
      {
        id: 1,
        title: "Art of Spelling",
        quote: "An open dialog to reconnect people to their magic.",
        description: "An interactive ceremony for intentional language. In-person gatherings where people use the ERB Alphabet to release what no longer serves and call in what wants to grow. The metaphysical alchemy to raising your vibration into alignment with the frequency of abundance.",
        features: ["Live ceremony events and retreats", "Facilitator training for community leaders", "A replicable ritual for communities everywhere"]
      },
      {
        id: 2,
        title: "Alphabet Soup for the Soil",
        quote: "Make bone broth with the skeletons in your closet.",
        description: "A transformation methodology rooted in nature's composting wisdom. The practice of cooking your past into nourishment for your future.",
        features: ["Guided content on personal transformation", "Workshops pairing inner work with soil education", "Philosophy bridging therapy, ecology, and alchemy"]
      },
      {
        id: 3,
        title: "Kepri Scarab",
        quote: "Rise like the soil's rose.",
        description: "Our philosophical anchor. The scarab teaches that transformation requires working with the difficult, not avoiding it.",
        features: ["Educational content on the metaphysics of soil", "Symbol system and merchandise", "Partnerships bridging ancient wisdom and modern regeneration", "Art installations using ERB alphabet"]
      },
      {
        id: 4,
        title: "Certification",
        quote: "Is it food? Or is it anti-food?",
        description: "A simple question that cuts through noise. ERB Certification will mark businesses, products, and locations that respect the soil.",
        features: ["Standards for consumers, producers, locations, materials", "A badge that means net-positive for soil", "Consumer education campaigns"]
      },
      {
        id: 5,
        title: "Path of Proceeds",
        quote: "A grounded form of consumer capitalism",
        description: "Full transparency on where money flows. Every purchase powers regenerative land management.",
        features: ["Transparent funding model", "Direct investment in regenerative projects", "Replicable framework for other soil-centric businesses"]
      },
      {
        id: 6,
        title: "Community",
        quote: "Decentralized community recentralized around enriching the soil",
        description: "Not a company. A frequency. A decentralized gathering united by one truth: the soil is sacred.",
        features: ["Membership and governance structure", "Network connecting consumers, producers, locations", "Collaborative ventures across industries"]
      }
    ]
  },
  closing: {
    title: "Your Purchase Plants the Seed",
    text: "These six seeds grow when you invest in the Sacred Soil Alphabet. Early supporters aren't just collectors—you're founders.",
    quote: "Living in sync with the soil cultivates a frequency of abundance"
  }
};